// import User from '@/models/User'
import * as MutationTypes from '../mutation-types'
import axios from 'axios'
// import router from '../../router/index'
// import { Notification } from 'element-ui'
import config from '../../config.js'
import { Notification } from 'element-ui'
// import dictionary from '../../store/dictionary'

const state = {
  currentChatUsers: [],
  allUsers: [],
  activeChat: {},
  myChats: [], // all that I can access private and public
  myExternalChats: [],
  creatingChatRoom: false,
  gettingChatRooms: false,
  deletingChatRoom: false,
  gettingChatRoom: false,
  sendingMessage: false,
  gettingChatRoomUsers: false,
  modifyingRoomUsers: false,
  myAvatar: '',
  savingAvatar: false
}
// todo: create chatroom post spinners and refresh chatrooms
// add users to existing chatroom has no save button!!!

const mutations = {
  [MutationTypes.ADD_CHATROOM] (state, roomDetails) {
    state.myChats.push(roomDetails.roomDetails)
  },
  [MutationTypes.SET_EXTERNAL_CHATROOMS] (state, { rootState, rooms }) {
    state.myExternalChats = rooms
    // const privateRoom = state.myChats.find(room => room.private)
    // state.myAvatar = privateRoom
    //   ? privateRoom.users.find(user => user.id === rootState.auth.user.id).avatar
    //   : 'whitePone'
  },
  [MutationTypes.SET_CHATROOMS] (state, {rootState, rooms}) {
    state.myChats = rooms
    const privateRoom = state.myChats.find(room => room.private)
    state.myAvatar = privateRoom
      ? privateRoom.users.find(user => user.id === rootState.auth.user.id).avatar
      : 'whitePone'
  },
  [MutationTypes.SET_CHATROOM] (state, {room, external}) {
    state.activeChat = room
    state.activeChat.external = external
    // const chat = state.myChats.find(chat => chat.id === state.activeChat.id)
    // chat.users.find
  },
  [MutationTypes.SAVE_AVATAR] (state, avatar) {
    state.avatar = avatar.avatar
  },
  [MutationTypes.SEND_MESSAGE] (state, message) {
    state.activeChat.messages.push(message.message)
  },
  [MutationTypes.ADD_USER_TO_CHATROOM] (state, userId) {
    // state.currentChatUsers.push(user.user)
  },
  [MutationTypes.REMOVE_USER_FROM_CHATROOM] (state, userId) {
    // state.currentChatUsers.filter(user => user.id !== userId)
  },
  [MutationTypes.SET_CURRENT_CHATROOM_USERS] (state, users) {
    state.currentChatUsers = users.users
  },
  [MutationTypes.SET_ALL_USERS] (state, users) {
    state.allUsers = users.users
  }
}

const getters = {
  allUsers (state) {
    return state.allUsers
  },
  creatingChatRoom (state) {
    return state.creatingChatRoom
  },
  savingAvatar (state) {
    return state.savingAvatar
  },
  myAvatar (state) {
    return state.myAvatar
  },
  avatars (state) {
    return [
      { id: 1, label: 'whiteKing' },
      { id: 2, label: 'whiteQueen' },
      { id: 3, label: 'whiteBishop' },
      { id: 4, label: 'whitePone' },
      { id: 5, label: 'whiteRook' },
      { id: 6, label: 'whiteKnight' }
    ]
  },
  haveNewMessages (state, rootState) {
    return !!state.myChats.find(chat => {
      const me = chat.users.find(user => user.id === (rootState.currentUser ? rootState.currentUser.id : ''))
      return me ? me.new_messages > 0 : false
    })
  },
  newMessagesPerRoom (state, rootState) {
    return state.myChats.map(chat => {
      const user = chat.users.find(user => user.id === (rootState.currentUser ? rootState.currentUser.id : '')) || false
      return { id: chat.id, name: chat.label, newMessages: user ? user.new_messages : 0 }
    })
  },
  newMessagesExternals (state, rootState) {
    return state.myExternalChats.map(chat => {
      // const user = chat.users.find(user => user.id === (rootState.currentUser ? rootState.currentUser.id : '')) || false
      return { id: chat.id, name: chat.label, newMessages: chat.new_external_messages }
    })
  },
  sendingMessage (state) {
    return state.sendingMessage
  },
  gettingChatRoomUsers (state) {
    return state.gettingChatRoomUsers
  },
  gettingChatRoom (state) {
    return state.gettingChatRoom
  },
  currentChatUsers (state) {
    return state.currentChatUsers
  },
  activeChat (state) {
    return state.activeChat
  },
  myChats (state) {
    return state.myChats
  },
  myExternalChats (state) {
    return state.myExternalChats
  },
  privateChats (state) {
    return state.myChats.filter(chat => chat.private)
  },
  publicChats (state) {
    return state.myChats.filter(chat => !chat.private)
  },
  // chatsForMe: [], // that I have subscribed in public and private
  // public chats that I participate in
  // ['a', 'b', 'c'].every(function (element, index) {
  //   // Do your thing, then:
  //   if (you_want_to_break) return false
  //   else return true
  // })
  myPubliChats (state, rootState) {
    let mychats = []
    state.myChats.forEach(chat => {
      chat.users.forEach(user => {
        if (user.id === (rootState.currentUser ? rootState.currentUser.id : '')) {
          mychats.push(chat)
        }
      })
    })
    return mychats.filter(chat => !chat.private)
  },
  modifyingRoomUsers (state) {
    return state.modifyingRoomUsers
  },
  gettingChatRooms (state) {
    return state.gettingChatRooms
  },
  deletingChatRoom (state) {
    return state.deletingChatRoom
  }
}

const actions = {
  SAVE_AVATAR: function ({ commit, dispatch, state, rootState }, avatar) {
    state.savingAvatar = true
    let p = axios.put(
      `${config.BASE_URL}/chatrooms/user`,
      { properties: avatar }
    ).then((response) => {
      state.savingAvatar = false
      commit(
        MutationTypes.SAVE_AVATAR,
        { avatar: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.savingAvatar = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  SEND_MESSAGE: function ({ commit, dispatch, state, rootState }, message) {
    state.sendingMessage = true
    const chatId = message.chatId
    delete message.chatId
    let p = axios.put(
      `${config.BASE_URL}/${message.external ? 'external/' : ''}chatrooms/${chatId}/message`,
      { message: message }
    ).then((response) => {
      state.sendingMessage = false
      commit(
        MutationTypes.SEND_MESSAGE,
        { message: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.sendingMessage = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
      return err
    })
    return p
  },
  ADD_USER_TO_CHATROOM ({ commit, dispatch, state, rootState }, { chatId, userId }) {
    state.modifyingRoomUsers = true
    let p = axios.post(
      `${config.BASE_URL}/chatrooms/${chatId}/user/${userId}`
    ).then((response) => {
      state.modifyingRoomUsers = false
      if (response.data.data === userId) {
        commit(
          MutationTypes.ADD_USER_TO_CHATROOM,
          { userId: response.data.data }
        )
      }
      dispatch('GET_CHATROOMS')
      // do I get currentChatUsers from the call or from the /chatrooms?
      // todo: refresh users in chatrooms.vue and chat.vue, manageChatRooms
      return response.data.data
    }, (err) => {
      state.modifyingRoomUsers = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  REMOVE_USER_FROM_CHATROOM ({ commit, dispatch, state, rootState }, { chatId, userId }) {
    state.modifyingRoomUsers = true
    let p = axios.delete(
      `${config.BASE_URL}/chatrooms/${chatId}/user/${userId}`
    ).then((response) => {
      state.modifyingRoomUsers = false
      if (response.data.data === userId) {
        commit(
          MutationTypes.REMOVE_USER_FROM_CHATROOM,
          { userId: response.data.data }
        )
      }
      dispatch('GET_CHATROOMS')
      // todo: refresh users in chatrooms.vue and chat.vue
      return response.data.data
    }, (err) => {
      state.modifyingRoomUsers = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  GET_ALL_USERS ({ commit, dispatch, state, rootState }) {
    state.gettingChatRoomUsers = true
    let p = axios.get(
      `${config.BASE_URL}/chatrooms/allusers`
    ).then((response) => {
      state.gettingChatRoomUsers = false
      commit(
        MutationTypes.SET_ALL_USERS, // todo: need to set them
        { users: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.gettingChatRoomUsers = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  GET_CURRENT_CHATROOM_USERS ({ commit, dispatch, state, rootState }, id) {
    state.gettingChatRoomUsers = true
    let p = axios.get(
      `${config.BASE_URL}/chatrooms/${id}/users`
    ).then((response) => {
      state.gettingChatRoomUsers = false
      commit(
        MutationTypes.SET_CURRENT_CHATROOM_USERS, // todo: need to set them
        { users: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.gettingChatRoomUsers = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  GET_CHATROOM: function ({ commit, dispatch, state, rootState }, { id, page, perPage, appId, external }) {
    state.gettingChatRoom = true
    let p = axios.get(
      `${config.BASE_URL}/${external ? 'external/' : ''}chatrooms/${id}?page=${page}&per_page=${perPage}${appId ? '&app_id=' + appId : ''}`
    ).then((response) => {
      state.gettingChatRoom = false
      commit(
        MutationTypes.SET_CHATROOM,
        { room: response.data.data, external: external }
      )
      return response.data.data
    }, (err) => {
      state.gettingChatRoom = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  DELETE_CHATROOM: function ({ commit, dispatch, state, rootState }, id) {
    state.deletingChatRoom = true
    let p = axios.delete(
      `${config.BASE_URL}/chatrooms/${id}`
    ).then((response) => {
      state.deletingChatRoom = true
      dispatch('GET_CHATROOMS')
      return response.data.data
    }, (err) => {
      state.deletingChatRoom = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
      return err
    })
    return p
  },
  GET_EXTERNAL_CHATROOMS: function ({ commit, dispatch, state, rootState }) {
    state.gettingChatRooms = true
    let p = axios.get(
      `${config.BASE_URL}/external/chatrooms`
    ).then((response) => {
      state.gettingChatRooms = false
      commit(
        MutationTypes.SET_EXTERNAL_CHATROOMS,
        { rootState, rooms: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.gettingChatRooms = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  GET_CHATROOMS: function ({ commit, dispatch, state, rootState }) {
    state.gettingChatRooms = true
    let p = axios.get(
      `${config.BASE_URL}/chatrooms`
    ).then((response) => {
      state.gettingChatRooms = false
      commit(
        MutationTypes.SET_CHATROOMS,
        { rootState, rooms: response.data.data }
      )
      return response.data.data
    }, (err) => {
      state.gettingChatRooms = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  },
  CREATE_CHATROOM: function ({ commit, dispatch, state, rootState }, {roomName, isPrivate}) {
    state.creatingChatRoom = true
    let p = axios.post(
      `${config.BASE_URL}/chatrooms`,
      {
        label: roomName,
        private: isPrivate
      }
    ).then((response) => {
      Notification.success({
        title: 'Επιτυχής Δημιουργία',
        message: response.data.message.text[0],
        offset: 100
      })
      state.creatingChatRoom = false
      dispatch('GET_CHATROOMS')
      return response.data.data
    }, (err) => {
      state.creatingChatRoom = false
      dispatch('BACKEND_ERROR_NOTIFY', err)
    })
    return p
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/chat.js